import { IUnitWithLocationDto } from 'api/api';

export function machineHasPositionOnMap(machineWithLocations: IUnitWithLocationDto[]): boolean {
    return machineWithLocations.some(
        s => (s.longitude && s.latitude) || (s.homeLatitude && s.homeLongitude)
    );
}